<template>
  <div class="file-uploader">
    <div class="unsupported-file-err" v-if="showUnsupportedFileTypeErr">
      <div class="err-container">
        <fa-icon icon="times" @click.stop="closeErrorPopup"/>
        <br/>
        <h3>Unsupported file type </h3>
        <h4>Please upload PDF or image.</h4>
      </div>
    </div>

    <div class="control" v-tooltip.left="'Share document'" @click="triggerFileUploader">
      <fa-icon v-if="!isUploading && !isProcessing" icon="cloud-upload-alt" size="lg"/>
      <input type="file" ref="uploader" @change="onInputUpload" @click="onClick"/>
      <div class="lds-ring" v-if="isUploading || isProcessing">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="progress" v-if="isUploading || isProcessing"> {{ progress }}%</div>
    </div>
  </div>
</template>

<script>
  import {uploadFile} from "../../services/apollo/upload";

  export default {
    name: "FileUploader",
    props: {
      callSid: {
        type: String
      },
      localDataTrack: {
        type: Object,
      }
    },

    data() {
      return {
        isUploading: false,
        isProcessing: false,
        progress: 0,
        showUnsupportedFileTypeErr: false
      }
    },

    methods: {
      onInputUpload(e) {
        let file = e.target.files[0];
        if (!file) {
          return false;
        }

        this.isUploading = true;
        this.upload(this.callSid, file);
      },
      onProgress(progress) {
        this.progress = parseInt(progress);
        if (this.progress === 100) {
          this.isProcessing = true;
        }
      },
      resetUploadProgress() {
        this.isProcessing = false;
        this.isUploading = false;
        this.progress = 0;
      },
      upload(callSid, file) {

        if (!["image/png", "image/jpg", "image/jpeg", "application/pdf"].includes(file.type)) {
          console.log('xx')
          this.showUnsupportedFileTypeErr = true;
          this.resetUploadProgress();
          return;
        }

        uploadFile({callSid, file, fileName: file.name}, {
          onProgress: this.onProgress
        })
          .then(file => {
            this.localDataTrack.send(`F,${file.fileUrl}`);
            this.resetUploadProgress();
          })
          .catch(err => console.log('err', err));
      },

      triggerFileUploader() {
        if (!this.isUploading) {
          this.$refs.uploader.click();
        }
      },
      closeErrorPopup() {
        this.showUnsupportedFileTypeErr = false
      },
      onClick(){
        this.$refs.uploader.value = '';
      }
    }
  }
</script>

<style lang="scss">
  @import "FileUploader";
</style>
